import { render } from "./1.LearnParallax.vue?vue&type=template&id=921cab6e&scoped=true"
import script from "./1.LearnParallax.vue?vue&type=script&lang=js"
export * from "./1.LearnParallax.vue?vue&type=script&lang=js"

import "./1.LearnParallax.vue?vue&type=style&index=0&id=921cab6e&scoped=true&lang=css"
import "./1.LearnParallax.vue?vue&type=style&index=1&id=921cab6e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921cab6e"]])

export default __exports__